
import axios from 'axios';
import { BASE_API_URL } from './baseServices';

export const fetchSuppliers = async (orgId) => {
    try {
        const response = await axios.get(`${BASE_API_URL}ADMINRoutes/GetSuppliers?OrgId=${orgId}`);
        return response.data.ResultData;
    } catch (error) {
        console.error('Error fetching suppliers:', error);
        throw error;
    }
};

export const addSupplier = async (data) => {
    const payload = {
      ...data
    };
  
    return axios.post(`${BASE_API_URL}ADMINRoutes/CreateSupplier`, payload);
};
  
export const updateSupplier = async (data) => {
    const payload = {
        ...data
    };

    return axios.post(`${BASE_API_URL}ADMINRoutes/EditSuppliers`, payload);
};

export const inActiveSupplier = async (data) => {
    const payload = {
        ...data
    };

    return axios.post(`${BASE_API_URL}ADMINRoutes/INACTIVESuppliers`, payload);
};
